export enum CheckinFiltersEnum {
  None = 0,
  Pending = 1,
  Done = 2,
}
